import ContactPrenom from '@/generated/controls/contact/ContactPrenom.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ContactPrenom
})
